// extracted by mini-css-extract-plugin
export default {"label":"ColoredLabel_label__qbrCU","uppercase":"ColoredLabel_uppercase__CTChD"};